import { AdminService } from '../../services/admin.service';
import { BudgetSetupService } from '../cv-admin-budget-setup/service/budget-setup.service';
import { BudgetSetupState } from '../../models/budget.model';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { TabItem, TabType } from '../../models/admin.model';
import { TabsComponent } from '@niceltd/sol/tabs';

@Component({
    selector: 'cv-admin-landing',
    templateUrl: './cv-admin-landing.component.html',
    styleUrls: ['./cv-admin-landing.component.scss']
})
export class CvAdminLandingComponent implements OnInit, OnDestroy {

    @ViewChild("adminTabs") adminTabs: TabsComponent;

    tabList: TabItem[] = [];
    isCxone = true;
    selectedTab = TabType.GAMES;
    budgetSetupState: BudgetSetupState;
    
    protected readonly tabType = TabType;
    private subscriptionBudgetSetup: Subscription = new Subscription();

    constructor(
        private adminService: AdminService,
        private cvConfigService: CvConfigurationService,
        private budgetSetupService: BudgetSetupService,
    ) {
        this.cvConfigService.isCxOne = true;
    }

    ngOnInit(): void {
        this.subscriptionBudgetSetup = this.budgetSetupService.budgetSetup$.subscribe(value => {
            this.budgetSetupState = value;
        });
        this.getAdminTabs();
    }

    ngOnDestroy(): void {
        this.subscriptionBudgetSetup.unsubscribe();
    }

    async getAdminTabs() {
        try {
            const tabs: TabItem[] = await this.adminService.loadAvailableTabs();
            this.tabList = tabs.filter((tab: TabItem) => tab.canRead);
        } catch (error) {
            console.error(error);
        }
    }

    onTabChanged(event: MatTabChangeEvent) {
        if (!this.budgetSetupState.editMode && event.tab.ariaLabel !== TabType.BUDGET) {
            setTimeout(() => {
                this.setTabGroupIndex(3);
            }, 0);
            this.budgetSetupService.onBudgetSetupUnsavedChanges(() => {
                this.onSuccessCallbackBudgetSetupModal()
            });
            this.budgetSetupService.budgetSetup.next({
                ...this.budgetSetupService.budgetSetup.value,
                lastIndex: event.index
            });
            return;
        }
        this.selectedTab = event.tab.ariaLabel as TabType;
    }

    onSuccessCallbackBudgetSetupModal(): void {
        this.budgetSetupService.budgetSetup.next({
            ...this.budgetSetupService.budgetSetup.value,
            editMode: true
        });
        this.setTabGroupIndex(this.budgetSetupState.lastIndex);
    }

    setTabGroupIndex(index: number): void {
        const tabGroup = this.adminTabs.tabGroup;
        tabGroup.selectedIndex = index;
    }
}
